module.exports = __webpack_public_path__ + "static/media/user-holder2.ce56b19c.svg";